import {useQueries} from 'react-query'
import {fetchStudentTripDetails, studentTripMutate} from './api'
import * as Yup from 'yup'
import {fetchActiveDropTrips, fetchActivePickupTrips} from '../trip/api'
import FormikControl from '../../../components/formikControl/FormikControl'
import {Form, Formik} from 'formik'
import toast from 'react-hot-toast'
import {RunnerBall} from '../../../components/FormLoader'
import {handleApiError} from '../../../helpers/errorHandler'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'

function TripDetails({initialValues, onAfterSubmit}) {
  const calls = [
    {
      queryKey: 'tripDet',
      queryFn: () => fetchStudentTripDetails(initialValues.student_id),
      initialValues: [],
      refetchOnWindowFocus: false,
    },
    {
      queryKey: 'active-pickup-trips',
      queryFn: fetchActivePickupTrips,
      initialValues: [],
      refetchOnWindowFocus: false,
    },
    {
      queryKey: 'active-drop-trips',
      queryFn: fetchActiveDropTrips,
      initialValues: [],
      refetchOnWindowFocus: false,
    },
  ]
  const results = useQueries(calls)

  if (results[0].isFetching || results[1].isFetching || results[2].isFetching) {
    return <RunnerBall />
  }

  const studentTrips = results[0]?.data.data || []
  const pickUpTrips = results[1]?.data.data || []
  const dropTrips = results[2]?.data.data || []

  const initialTripData = {
    pickup_trip_id: studentTrips.find((trip) => trip.trip_type === 'pickup')?.trip_id,
    student_pickup_trip_id: studentTrips.find((trip) => trip.trip_type === 'pickup')
      ?.student_bus_trip_id,
    drop_trip_id: studentTrips.find((trip) => trip.trip_type === 'drop')?.trip_id,
    student_drop_trip_id: studentTrips.find((trip) => trip.trip_type === 'drop')
      ?.student_bus_trip_id,
  }

  const submitHandler = async (values, {setSubmitting: setLoading}) => {
    setLoading(true)
    values.student_id = initialValues.student_id

    const toastId = toast.loading('Submitting')
    try {
      // if (!initialTripData.pickup_trip_id) {
      await studentTripMutate({
        student_id: initialValues.student_id,
        pickup_trip_id: values.pickup_trip_id || 0,
        drop_trip_id: values.drop_trip_id || 0,
      })
      // } else {
      //   await updateStudentTrip({
      //     student_bus_trip_id: initialTripData.student_pickup_trip_id,
      //     trip_id: values.pickup_trip_id,
      //   })
      // }
      // if (!initialTripData.drop_trip_id) {
      //   await createStudentTrip({
      //     student_id: initialValues.student_id,
      //     trip_id: values.drop_trip_id,
      //   })
      // } else {
      //   await updateStudentTrip({
      //     student_bus_trip_id: initialTripData.student_drop_trip_id,
      //     trip_id: values.drop_trip_id,
      //   })
      // }
      toast.success('Success', {id: toastId})
      setLoading(false)
      onAfterSubmit()
    } catch (error) {
      setLoading(false)
      handleApiError(error, toastId)
    }
  }

  const formValues = initialTripData || {
    pickup_trip_id: '',
    drop_trip_id: '',
  }

  return (
    <div className="px-5 py-3">
      <Formik
        initialValues={formValues}
        validationSchema={Yup.object({
          pickup_trip_id: Yup.string(),
          drop_trip_id: Yup.string(),
        })}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, values, dirty, isValid}) => (
          <Form>
            <FormikControl
              control={'select-advanced'}
              options={pickUpTrips}
              placeholder="Pick Up"
              name="pickup_trip_id"
              label="Pick Up"
              value={pickUpTrips.find((pick) => pick.trip_id === values.pickup_trip_id) || ''}
              optionLabel={'trip_name'}
              optionValue={'trip_id'}
            />
            <FormikControl
              control={'select-advanced'}
              options={dropTrips}
              placeholder="Drop"
              name="drop_trip_id"
              label="Drop"
              value={dropTrips.find((drop) => drop.trip_id === values.drop_trip_id) || ''}
              optionLabel={'trip_name'}
              optionValue={'trip_id'}
            />
            <div className="text-center pt-10">
              <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

              <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default TripDetails
